export default __webpack_public_path__ + "static/media/user.2c8e0963.svg";